module.exports = __webpack_public_path__ + "media/src/images/posters_points-928c45d3a73df9a9efe3712028f6f300.png";